// extracted by mini-css-extract-plugin
export default {"wrapper":"ky","noPadding":"ly","flavor_wrapper":"my","flavor_button":"ny","vert":"oy","itemContent":"py","itemName":"qy","blue":"ry","out_of_stock":"sy","newFlavorBadge":"ty","fullWidth":"uy","flavor_button_selected":"vy","black":"wy","attribute_wrapper":"xy","toggle_wrapper":"yy"};
    if(module.hot) {
      // 1713809678037
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  